
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import ProgressBar from '@/components/ui/ProgressBar';

interface ProgressTabProps {
  level: number;
  xpProgress: number;
  totalXP: number;
}

const ProgressTab: React.FC<ProgressTabProps> = ({
  level,
  xpProgress,
  totalXP
}) => {
  const levels = Array.from({ length: 5 }, (_, i) => ({
    level: i + 1,
    xpRequired: (i + 1) * 300,
    completed: level > i + 1 || (level === i + 1 && xpProgress === 100)
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Level Progress</CardTitle>
        <CardDescription>Your journey to becoming a French expert</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {levels.map((levelData, index) => (
          <div key={index} className={`relative ${index !== levels.length - 1 ? "pb-6" : ""}`}>
            <div className="flex items-center gap-3">
              <div className={`h-10 w-10 rounded-full flex items-center justify-center ${levelData.completed ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"}`}>
                {levelData.level}
              </div>
              <div className="flex-1">
                <div className="flex justify-between items-center">
                  <h3 className="font-medium">Level {levelData.level}</h3>
                  <span className="text-sm text-muted-foreground">{levelData.xpRequired} XP</span>
                </div>
                <ProgressBar 
                  value={levelData.level === level ? xpProgress : (levelData.completed ? 100 : 0)} 
                  max={100} 
                  size="sm"
                  className="mt-1" 
                />
              </div>
            </div>
            
            {index !== levels.length - 1 && (
              <div className={`absolute left-5 top-10 w-[1px] h-6 ${levelData.completed ? "bg-primary" : "bg-muted"}`}></div>
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default ProgressTab;
